/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  var VideoApp = (() => {
    var play = (container) => {
      if (!container) return;

      pause(container);

      let video = null;
      if (window.innerWidth < 768)
        video = container.querySelector('[js-mobile-video] video');
      else
        video = container.querySelector('[js-desktop-video] video');

      if (video) {
        video.closest('[js-video]').classList.add('playing');
        video.play();
      }
    }

    var pause = (container) => {
      if (!container) return;

      container.querySelectorAll('[js-video] video').forEach(video => {
        video.pause();
        video.closest('[js-video]').classList.remove('playing');
      });
    }

    var initialize = () => {
      document.querySelectorAll('[js-new-video-container][autoplay="true"]').forEach(element => {
        if (element.getAttribute('autoplay') === 'true') {
          play(element);
        } else {
          pause(element);
        }
      });

      document.querySelectorAll('[js-new-video-container] [js-video-play]').forEach(element => {
        element.addEventListener('click', () => {
          play(element.closest('[js-new-video-container]'));
        });
      });

      document.querySelectorAll('[js-new-video-container] [js-video] video').forEach(element => {
        element.addEventListener('click', () => {
          // pause(element.closest('[js-new-video-container]'));
        });
        element.addEventListener('ended', () => {
          play(element.closest('[js-new-video-container]'));
        });
      });


    }

    return {
      init: initialize
    }
  })();


  // [BD feat] Sticky ATC button on PDP
  var StickyATCButton = (() => {
    let stickyATCContainer = null;
    let submitButton = null;

    var setVariantDetails = () => {
      const productForm = document.querySelector('body.template-product form[data-product-form] [data-product-select]');
      if (!productForm) return;
      const currentVariantId = productForm.value;
      stickyATCContainer.querySelectorAll('[js-variant-info]').forEach(element => {
        element.classList.remove('selected');
        if (element.getAttribute('data-variant-id') == currentVariantId) {
          element.classList.add('selected');
        }
      });
    }
    var show = () => {
      if (!stickyATCContainer) return;
      setVariantDetails();
      document.body.classList.add('has-product-sticky-atc');
    }
    var hide = () => {
      if (!stickyATCContainer) return;
      document.body.classList.remove('has-product-sticky-atc');
    }
    var checkMainATCIsInViewport = () => {
      const mainATCButton = document.querySelector('body.template-product form[data-product-form] [data-add-to-cart][type="submit"]');
      if (!mainATCButton) return;
      if (mainATCButton.getBoundingClientRect().top > (-1 * mainATCButton.getBoundingClientRect().height)) {
        hide();
      } else {
        show();
      }
    }
    var submit = () => {
      if (!submitButton) return;
      const productForm = document.querySelector('body.template-product form[data-product-form]');
      if (!productForm) return;
      window.scrollTo(0, window.scrollY + productForm.getBoundingClientRect().top - 100);
    }
    var initialize = () => {
      stickyATCContainer = document.querySelector('[js-product-sticky-add-to-cart]');
      if (!stickyATCContainer) return;

      const productForm = document.querySelector('body.template-product form[data-product-form] [data-product-select]');
      if (!productForm) return;
      productForm.addEventListener('change', () => {
        setVariantDetails();
      });

      submitButton = stickyATCContainer.querySelector('[js-sticky-atc-button]');
      if (!submitButton) return;
      submitButton.addEventListener('click', () => {
        submit();
      });
    }
    return {
      init: initialize,
      check: checkMainATCIsInViewport
    }
  })();


  var ShowMoreLessApp = (() => {
    var open = (container) => {
      if (!container) return;
      const element = container.querySelector('[js-show-more-content]');
      if (!element) return;
      let duration = parseInt(container.getAttribute('data-duration'));
      duration = (duration>0)?duration:300;
      element.classList.add('open');
      element.style.maxHeight = element.scrollHeight + 'px';
      setTimeout(() => {
        element.style.maxHeight = 'fit-content';
      }, duration);
    }
    var close = (container) => {
      if (!container) return;
      const element = container.querySelector('[js-show-more-content]');
      if (!element) return;
      element.style.maxHeight = element.scrollHeight + 'px';
      setTimeout(() => {
        element.classList.remove('open');
        element.style.maxHeight = '0px';
      });
    }
    var initialize = () => {
      document.querySelectorAll('[js-container] [js-show-more]').forEach(showMoreButton => {
        showMoreButton.addEventListener('click', () => {
          open(showMoreButton.closest('[js-container]'));
        });
      });
      document.querySelectorAll('[js-container] [js-show-less]').forEach(showLessButton => {
        showLessButton.addEventListener('click', () => {
          close(showLessButton.closest('[js-container]'));
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var BDMarqueeApp = (() => {
    var intervalIdList = {};
    var play = (element, index) => {
      if (!element || element.classList.contains('playing')) return;
      element.classList.add('playing');
      const intervalId = setInterval(() => {
        let scrollLeft = element.scrollLeft;
        scrollLeft = (scrollLeft-1>=0)?(scrollLeft-1):(element.scrollWidth-element.offsetWidth);
        element.scrollTo(scrollLeft, 0);
      }, 15);
      intervalIdList[index] = intervalId;
    }
    var pause = (element, index) => {
      element.classList.remove('playing');
      clearInterval(intervalIdList[index]);
    }
    var initialize = () => {
      document.querySelectorAll('[js-bd-marquee]').forEach((element, index) => {
        element.scrollTo(element.scrollWidth - element.offsetWidth, 0);
        play(element, index);
        element.addEventListener('mouseover', () => {
          pause(element, index);
        });
        element.addEventListener('mouseleave', () => {
          play(element, index);
        });
      });
    }
    return {
      init: initialize
    }
  })();


  var AnchorToATCButtonApp = (() => {
    var goToATC = () => {
      const productForm = document.querySelector('body.template-product form[data-product-form]');
      if (!productForm) return;
      window.scrollTo(0, window.scrollY + productForm.getBoundingClientRect().top - 100);
    }
    var initialize = () => {
      document.querySelectorAll('[js-anchor-to-atc]').forEach(element => {
        element.addEventListener('click', () => {
          goToATC();
        });
      });
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
      const cartDrawer = document.querySelector('#cart-drawer');
      console.log("cartDrawer", cartDrawer);
      if (cartDrawer) {
        const observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.type === 'childList') {
              const cartItemsHolder = document.getElementById('cartItemsHolder');
              const cartDrawerDivider = document.querySelector('.cart-drawer__divider');
              console.log("cartItemsHolder", cartItemsHolder);
              console.log("cartDrawerDivider", cartDrawerDivider);
              if (cartItemsHolder) {
                if (cartItemsHolder.children.length >= 1) {
                  cartDrawerDivider.style.display = 'block';
                } else {
                  cartDrawerDivider.style.display = 'none';
                }
              }
            }
          });
        });

        observer.observe(cartDrawer, { childList: true, subtree: true });
      }
    }, 300);
    VideoApp.init();
    StickyATCButton.init();
    ShowMoreLessApp.init();
    BDMarqueeApp.init();
    AnchorToATCButtonApp.init();
  });

  window.addEventListener('scroll', () => {
    StickyATCButton.check();
  });



  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
